import { ERoles } from "../config";

export function canShowForSuperAdminOrResellerAdmin (user) {
    return user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN || user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN;
}
